import { makeUrl } from "../utils/urls";
import { postApi } from "./apiCalls";

export const getOrCreateCustomer = (phone_number) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl("riders/customers/get-or-create-user");
    postApi(url, { phone_number }, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
